import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './views/home/Home';
import WaitingRoom from './views/waitingRoom/WaitingRoom';
import PrepRoom from './views/prepRoom/PrepRoom';
import InGame from './views/inGame/InGame';
import Layout from './views/home/Layout';

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Switch>
                    <Route exact path='/'>
                        <Home />
                    </Route>
                    <Route exact path='/waitingRoom'>
                        <WaitingRoom />
                    </Route>
                    <Route exact path='/prepRoom'>
                        <PrepRoom />
                    </Route>
                    <Route exact path='/game'>
                        <InGame />
                    </Route>
                </Switch>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
